/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_EmptyInputs */

const id_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada file yang cocok dengan perbandingan ini.`)
};

const ms_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada fail sepadan dengan perbandingan ini.`)
};

const da_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen filer matcher denne sammenligning.`)
};

const de_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Dateien entsprechen diesem Vergleich.`)
};

const en_us2_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files match this comparison.`)
};

const es_es2_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún archivo coincide con esta comparación.`)
};

const es_mx2_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún archivo coincide con esta comparación.`)
};

const fil_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang file na tumutugma sa paghahambing na ito.`)
};

const fr_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun fichier ne correspond à cette comparaison.`)
};

const it_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun file corrisponde a questo confronto.`)
};

const hu_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyetlen fájl sem felel meg ennek az összehasonlításnak.`)
};

const nl_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen bestanden komen overeen met deze vergelijking.`)
};

const no_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen filer samsvarer med denne sammenligningen.`)
};

const pl_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak plików pasujących do tego porównania.`)
};

const pt_br2_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum arquivo corresponde a esta comparação.`)
};

const pt_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum ficheiro corresponde a esta comparação.`)
};

const ro_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niciun fișier nu corespunde acestei comparații.`)
};

const fi_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksikään tiedosto ei vastaa tätä vertailua.`)
};

const sv_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga filer matchar den här jämförelsen.`)
};

const vi_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có tệp nào khớp với so sánh này.`)
};

const tr_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu karşılaştırmayla eşleşen dosya yok.`)
};

const cs_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné soubory neodpovídají tomuto porovnání.`)
};

const bg_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма файлове, отговарящи на това сравнение.`)
};

const ru_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет файлов, соответствующих этому сравнению.`)
};

const uk_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає файлів, що відповідають цьому порівнянню.`)
};

const ar_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد ملفات تطابق هذه المقارنة.`)
};

const hi_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस तुलना से मेल खाने वाली कोई फ़ाइल नहीं है।`)
};

const th_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีไฟล์ที่ตรงกับการเปรียบเทียบนี้`)
};

const ja_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この比較に一致するファイルはありません。`)
};

const zh_cn2_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有文件匹配此比较结果。`)
};

const zh_hant1_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有檔案符合此比較結果。`)
};

const ko_builds_comparison_empty = /** @type {(inputs: Builds_Comparison_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 비교와 일치하는 파일이 없습니다.`)
};

/**
* | output |
* | --- |
* | "No files match this comparison." |
*
* @param {Builds_Comparison_EmptyInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_empty = /** @type {((inputs?: Builds_Comparison_EmptyInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_EmptyInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_empty(inputs)
	if (locale === "ms") return ms_builds_comparison_empty(inputs)
	if (locale === "da") return da_builds_comparison_empty(inputs)
	if (locale === "de") return de_builds_comparison_empty(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_empty(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_empty(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_empty(inputs)
	if (locale === "fil") return fil_builds_comparison_empty(inputs)
	if (locale === "fr") return fr_builds_comparison_empty(inputs)
	if (locale === "it") return it_builds_comparison_empty(inputs)
	if (locale === "hu") return hu_builds_comparison_empty(inputs)
	if (locale === "nl") return nl_builds_comparison_empty(inputs)
	if (locale === "no") return no_builds_comparison_empty(inputs)
	if (locale === "pl") return pl_builds_comparison_empty(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_empty(inputs)
	if (locale === "pt") return pt_builds_comparison_empty(inputs)
	if (locale === "ro") return ro_builds_comparison_empty(inputs)
	if (locale === "fi") return fi_builds_comparison_empty(inputs)
	if (locale === "sv") return sv_builds_comparison_empty(inputs)
	if (locale === "vi") return vi_builds_comparison_empty(inputs)
	if (locale === "tr") return tr_builds_comparison_empty(inputs)
	if (locale === "cs") return cs_builds_comparison_empty(inputs)
	if (locale === "bg") return bg_builds_comparison_empty(inputs)
	if (locale === "ru") return ru_builds_comparison_empty(inputs)
	if (locale === "uk") return uk_builds_comparison_empty(inputs)
	if (locale === "ar") return ar_builds_comparison_empty(inputs)
	if (locale === "hi") return hi_builds_comparison_empty(inputs)
	if (locale === "th") return th_builds_comparison_empty(inputs)
	if (locale === "ja") return ja_builds_comparison_empty(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_empty(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_empty(inputs)
	return ko_builds_comparison_empty(inputs)
});
export { builds_comparison_empty as "builds.comparison.empty" }